import firebase from "firebase/app";
import * as geofirex from "geofirex";

import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";

// Initialize Firebase
const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
const authDomain = process.env.REACT_APP_AUTH_DOMAIN;
const databaseURL = process.env.REACT_APP_DATABASE_URL;
const projectId = process.env.REACT_APP_PROJECT_ID;
const storageBucket = process.env.REACT_APP_STORAGE_BUCKET;
const messagingSenderId = process.env.REACT_APP_MESSAGING_SENDER_ID;
const appId = process.env.REACT_APP_APP_ID;
const measurementId = process.env.REACT_APP_MEASUREMENT_ID;

const firebaseConfig = {
	apiKey,
	authDomain,
	databaseURL,
	projectId,
	storageBucket,
	messagingSenderId,
	appId,
	measurementId
};

export const firebaseProjectId = projectId;

export const fbApp = firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

export const firestore = firebase.firestore();
// Route Firestore to the local emulator (separate flag from functions) so
// promotions written here fire the local onPromotionsUpdate trigger. The
// emulator's Firestore must be seeded/imported with your user + data first.
// firebase v7 has no useEmulator(); configure the host via settings() before use.
if (process.env.REACT_APP_USE_FIRESTORE_EMULATOR === "true") {
	firestore.settings({ host: "localhost:8080", ssl: false });
	// eslint-disable-next-line no-console
	console.warn("[dev] Using local Firestore emulator at localhost:8080");
}
export const geo = geofirex.init(firebase);

export const storage = firebase.storage();
export const imageRef = storage.ref("images/");
export const profileImageRef = storage.ref("profileImages/");
export const localAdsImageRef = storage.ref("localAds/");
export const feedAdsImageRef = storage.ref("feedAds/");

export const functions = firebase.functions();
// Point the web app at the locally-running Firebase Functions emulator when
// REACT_APP_USE_EMULATOR=true. This keeps dev fully isolated from deployed
// functions (which use the prod Supabase project). See bhpr-supabase/scripts.
if (process.env.REACT_APP_USE_EMULATOR === "true") {
	functions.useFunctionsEmulator("http://localhost:5001");
	// eslint-disable-next-line no-console
	console.warn("[dev] Using local Firebase Functions emulator at http://localhost:5001");
}

export const EmailAuthProvider = firebase.auth.EmailAuthProvider;
export const LOCAL_PERSIST = firebase.auth.Auth.Persistence.LOCAL;

export const getDeleteSentinel = firebase.firestore.FieldValue.delete;

export { firebase };
